import React, { useEffect, useState, useRef } from 'react';
import { StarIcon, UserIcon, ChevronLeftIcon, ChevronRightIcon, ExternalLinkIcon } from 'lucide-react';
export const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);
  const testimonials = [{
    id: 1,
    name: 'Elizaveta Mirgorodskaya',
    text: 'Zeer goede ervaring! Ik liet de muren en plafonds stucen en elektra aanleggen. Alles snel, professioneel en voor een nette prijs.',
    rating: 5,
    project: 'Stucwerk & elektra',
    image: null
  }, {
    id: 2,
    name: 'Selimhan Unal',
    text: 'Mijn volledige woning is gerenoveerd door BTB Bouwbedrijf. Ik ben erg tevreden met het eindresultaat!',
    rating: 5,
    project: 'Totale renovatie',
    image: null
  }, {
    id: 3,
    name: 'Emre Engin',
    text: 'Topservice. Geen opmerking, alles goed geregeld.',
    rating: 5,
    project: 'Renovatie',
    image: null
  }, {
    id: 4,
    name: 'Mohamed Elbarghouti',
    text: 'Top bedrijf. Heldere communicatie en professioneel uitgevoerd. Zeker een aanrader!',
    rating: 5,
    project: 'Algemene renovatie',
    image: null
  }, {
    id: 5,
    name: 'Adem',
    text: 'Zeer tevreden over de werkzaamheden. Vakmensen, professioneel en betrouwbaar.',
    rating: 5,
    project: 'Renovatie',
    image: null
  }, {
    id: 6,
    name: 'Carla Treviño',
    text: 'BTB heeft goed werk geleverd. Ze kwamen zelfs terug om kleine dingen te corrigeren. Service achteraf was top!',
    rating: 5,
    project: 'Herstelwerk na oplevering',
    image: null
  }];
  const totalSlides = testimonials.length;
  const slidesToShow = {
    mobile: 1,
    desktop: 2
  };
  const maxIndex = totalSlides - slidesToShow.desktop;
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || window.pageYOffset;
      const windowHeight = window.innerHeight;
      // Show testimonials when user has scrolled 30% of the page
      if (scrollY > windowHeight * 0.3) {
        setIsVisible(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    // Check initial position in case user has already scrolled
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  const handlePrev = () => {
    setCurrentIndex(prevIndex => Math.max(prevIndex - 1, 0));
  };
  const handleNext = () => {
    setCurrentIndex(prevIndex => Math.min(prevIndex + 1, maxIndex));
  };
  // Determine if arrows should be disabled
  const isPrevDisabled = currentIndex === 0;
  const isNextDisabled = currentIndex >= maxIndex;
  return <div className={`mt-16 mb-12 py-6 transition-all duration-1000 ease-in-out ${isVisible ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10'}`} data-id="element-493">
      <div className="text-center mb-2" data-id="element-494">
        <h2 className="text-2xl font-semibold text-[#111010]" data-id="element-495">
          Wat onze klanten zeggen
        </h2>
      </div>
      {/* Google reviews badge using the provided image */}
      <div className="flex justify-center mb-8" data-id="element-496">
        
      </div>
      <div className="relative" data-id="element-497">
        {/* Desktop navigation arrows */}
        <div className="hidden md:block absolute top-1/2 left-0 -translate-y-1/2 -translate-x-4 z-10 md:-translate-x-6" data-id="element-498">
          <button onClick={handlePrev} disabled={isPrevDisabled} className={`rounded-full bg-white p-2 border border-gray-200 shadow-sm transition-all duration-300 ${isPrevDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-md'}`} aria-label="Vorige review" data-id="element-499">
            <ChevronLeftIcon className="h-5 w-5 text-[#111010]" data-id="element-500" />
          </button>
        </div>
        <div className="hidden md:block absolute top-1/2 right-0 -translate-y-1/2 translate-x-4 z-10 md:translate-x-6" data-id="element-501">
          <button onClick={handleNext} disabled={isNextDisabled} className={`rounded-full bg-white p-2 border border-gray-200 shadow-sm transition-all duration-300 ${isNextDisabled ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-md'}`} aria-label="Volgende review" data-id="element-502">
            <ChevronRightIcon className="h-5 w-5 text-[#111010]" data-id="element-503" />
          </button>
        </div>
        {/* Testimonial slider */}
        <div className="overflow-hidden px-2 md:px-8" data-id="element-504">
          <div ref={sliderRef} className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${currentIndex * (100 / slidesToShow.desktop)}%)`
        }} data-id="element-505">
            {testimonials.map(testimonial => <div key={testimonial.id} className="w-full md:w-1/2 flex-shrink-0 px-2 md:px-4" data-id="element-506">
                <div className="bg-white h-full p-4 md:p-5 rounded-md border border-gray-200 shadow-sm flex flex-col" data-id="element-507">
                  <div className="flex items-center space-x-1 mb-3" data-id="element-508">
                    {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < testimonial.rating ? 'text-[#FCCA86]' : 'text-gray-300'}`} fill={i < testimonial.rating ? 'currentColor' : 'none'} data-id="element-509" />)}
                  </div>
                  <p className="text-gray-700 text-sm md:text-base flex-grow mb-4" data-id="element-510">
                    "{testimonial.text}"
                  </p>
                  <div className="mt-auto flex items-center" data-id="element-511">
                    <div className="h-8 w-8 md:h-9 md:w-9 rounded-full border border-gray-200 bg-gray-50 flex items-center justify-center flex-shrink-0" data-id="element-512">
                      <UserIcon className="h-4 w-4 md:h-5 md:w-5 text-gray-400" data-id="element-513" />
                    </div>
                    <div className="ml-3 overflow-hidden" data-id="element-514">
                      <p className="font-medium text-gray-800 text-sm md:text-base truncate" data-id="element-515">
                        {testimonial.name}
                      </p>
                      <p className="text-xs text-gray-500" data-id="element-516">
                        {testimonial.project}
                      </p>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
        {/* Redesigned Mobile navigation buttons (bottom) */}
        <div className="flex justify-center mt-6 md:hidden" data-id="element-517">
          <div className="flex items-center bg-white rounded-full shadow-sm border border-gray-200 p-1" data-id="element-518">
            <button onClick={handlePrev} disabled={isPrevDisabled} className={`rounded-full p-2 transition-colors ${isPrevDisabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-50'}`} aria-label="Vorige review" data-id="element-519">
              <ChevronLeftIcon className="h-5 w-5" data-id="element-520" />
            </button>
            {/* Numbered pagination indicator */}
            <div className="px-3 text-sm font-medium text-gray-700" data-id="element-521">
              {currentIndex + 1} / {maxIndex + 1}
            </div>
            <button onClick={handleNext} disabled={isNextDisabled} className={`rounded-full p-2 transition-colors ${isNextDisabled ? 'text-gray-300 cursor-not-allowed' : 'text-gray-700 hover:bg-gray-50'}`} aria-label="Volgende review" data-id="element-522">
              <ChevronRightIcon className="h-5 w-5" data-id="element-523" />
            </button>
          </div>
        </div>
        {/* Desktop pagination dots - only visible on desktop */}
        <div className="hidden md:flex justify-center mt-5 space-x-1.5" data-id="element-524">
          {[...Array(maxIndex + 1)].map((_, i) => <button key={i} onClick={() => setCurrentIndex(i)} className={`transition-all duration-300 ${i === currentIndex ? 'bg-[#FCCA86] w-6 h-2 rounded-full' : 'bg-gray-300 w-2 h-2 rounded-full hover:bg-gray-400'}`} aria-label={`Ga naar review set ${i + 1}`} data-id="element-525" />)}
        </div>
      </div>
      {/* Simplified Google reviews bar */}
      <div className="mt-8 max-w-xl mx-auto" data-id="element-526">
        <div className="bg-white rounded-md border border-gray-200 shadow-sm p-3 flex flex-wrap items-center justify-between" data-id="element-527">
          <div className="flex items-center" data-id="element-528">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mWM3T2uuqqHxfiBQqyihgY/Google-Review-Logo.png" alt="Google Reviews" className="h-8 mr-3" data-id="element-529" />
            <div className="flex items-center" data-id="element-530">
              <span className="font-semibold text-gray-800 mr-2" data-id="element-531">5.0</span>
              <div className="flex" data-id="element-532">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-4 w-4 text-[#FCCA86] fill-current" data-id="element-533" />)}
              </div>
              <span className="ml-2 text-sm text-gray-600" data-id="element-534">(127)</span>
            </div>
          </div>
          <a href="https://www.google.com/search?q=BTB+Bouwbedrijf+Reviews" target="_blank" rel="noopener noreferrer" className="mt-2 sm:mt-0 inline-flex items-center justify-center px-3 py-1.5 bg-[#4285F4] text-white rounded text-xs font-medium hover:bg-[#3367d6] transition-all duration-300" data-id="element-535">
            Bekijk op Google
            <ExternalLinkIcon className="ml-1 h-3 w-3" data-id="element-536" />
          </a>
        </div>
      </div>
    </div>;
};